import Skeleton from "react-loading-skeleton";
import type { ProductCategory } from "~/types";
import { Box } from "../Box/Box";
import { CategoryDropdown } from "./CategoryDropdown";
import { CategorySearch } from "./CategorySearch";

export function CategoryBar({
  menu,
  selectedCategory,
  onSelectCategory,
  searchValue,
  onSearch,
  loading,
}: {
  menu: ProductCategory[];
  searchValue: string;
  selectedCategory: ProductCategory | undefined;
  onSearch: (value: string) => void;
  onSelectCategory: (category: ProductCategory) => void;
  loading: boolean;
}): React.ReactNode {
  return (
    <Box
      display="flex"
      position="relative"
      height="touchable"
      width="full"
      justifyContent="center"
      background="jets-beige"
      overflow="hidden"
      style={{ gap: 10 }}
    >
      {loading ? (
        <>
          <Box flexGrow={1} style={{ lineHeight: 1 }}>
            <Skeleton style={{ flex: 1 }} height={48} />
          </Box>
          <Box style={{ lineHeight: 1 }}>
            <Skeleton width={48} height={48} />
          </Box>
        </>
      ) : (
        <>
          <CategoryDropdown
            menu={menu}
            onSelectCategory={onSelectCategory}
            selectedCategory={selectedCategory}
          />
          <CategorySearch value={searchValue} onChange={onSearch} />
        </>
      )}
    </Box>
  );
}
